import { apiRequest } from "@core/services/api/apiRequest";

export type UpdateUserPhoneArgs = {
  phoneNumber: string;
  /** Whether to enable SMS/text notifications */
  isTextNotificationsEnabled?: boolean;
};

export type UpdateUserPhoneResponse = {
  message: string;
  user_data: Record<string, unknown>;
};

/**
 * Updates user phone number and optionally text notification preferences via the profile API
 */
export async function updateUserPhone({
  phoneNumber,
  isTextNotificationsEnabled,
}: UpdateUserPhoneArgs): Promise<UpdateUserPhoneResponse> {
  const response = (await apiRequest(`/profile/`, "POST", {
    phone_number: phoneNumber,
    ...(isTextNotificationsEnabled !== undefined && {
      is_text_notifications_enabled: isTextNotificationsEnabled,
    }),
  })) as UpdateUserPhoneResponse;

  return response;
}

export default updateUserPhone;
